import type { BotMessage } from '../../types/leadBot.js';

// WHAT A THREAD MESSAGE IS. A conversation holds three kinds: what the LEAD said, what WE sent, and SYSTEM EVENTS
// (a missed-call note, the speed-to-lead "we tried to call" note). A system event is neither of the first two.
//
// ⚠️⚠️ EVERY reader that means "the lead said something" goes through `isLeadMessage`, never `direction === 'inbound'`
// alone. Counting a system note as a lead reply inflates reply rates, ends the "has not replied" follow-up sequence,
// makes an opening look like a reply, and feeds our own note to the model as the lead's words.
//
// New notes are stored with direction 'system'. Older missed-call notes were stored as inbound + `callEvent`; both are
// recognised here so nothing depends on the migration having been run (scripts/migrate-lead-bot-system-notes.ts).

export type MessageKindFields = Pick<BotMessage, 'direction'> & { callEvent?: boolean };

/** A system event on the thread (new shape, or a legacy inbound call note). */
export function isSystemEvent(m: MessageKindFields): boolean {
  return m.direction === 'system' || m.callEvent === true;
}

/** Something the LEAD wrote. A system event, and a reaction where the caller says so, are not. */
export function isLeadMessage(m: MessageKindFields): boolean {
  return m.direction === 'inbound' && !isSystemEvent(m);
}
